export const employeesSelector = (state) => state.employees.employees;
export const employeeSelector = (state) => state.employees.employee;
export const employeeLoadingSelector = (state) => state.employees.loading;
